import React from "react";
import { Box } from "@mui/material";
import noImgPlaceholder from "../../Assets/no-img-placeholder.png";

/**
 * Renders an asset image with a local placeholder when the URL is missing or fails to load.
 */
export default function AssetOwnerImage({ src, alt = "", sx, style, ...rest }) {
  const hasSrc = src != null && String(src).trim() !== "";
  const resolvedSrc = hasSrc ? src : noImgPlaceholder;

  const handleError = (e) => {
    const el = e.currentTarget;
    if (el.getAttribute("data-asset-owner-img-fallback") === "1") return;
    el.setAttribute("data-asset-owner-img-fallback", "1");
    el.src = noImgPlaceholder;
  };

  return (
    <Box
      component="img"
      src={resolvedSrc}
      alt={alt}
      onError={handleError}
      sx={sx}
      style={style}
      {...rest}
    />
  );
}
